<template>
    <md-dialog md-open-from="#resetPage" md-close-to="#resetPage" ref="resetPage">
        <div style="text-align: center;">
            <div style="padding: 14px;padding-bottom: 0px;" >
                <md-dialog-content>
                    <p>{{displayPopupTitle}}</p>
                    <br/>
                    <md-input-container v-if="addResetOption == 'custom' || toolbarManuTypeName == 'adjustSelectedPages'">
                        <label for="enter-starting-number">Enter Starting Number</label>
                        <md-input 
                            type="text" 
                            required 
                            v-model.trim="startingNumber" 
                            @input="addValidateNumber"
                        />
                    </md-input-container>
                    <div class="from-to" v-if="toolbarManuTypeName == 'resetAllPages'">
                            <md-radio v-model="addResetOption" mdValue="default">Default (1)</md-radio>
                            <md-radio v-model="addResetOption" mdValue="custom">Custom</md-radio>
                    </div>
                    <p v-if="addErrorFromMessage" class="error">{{ addErrorFromMessage }}</p>
                    <md-button class="md-primary md-raised" style="margin-bottom: 25px;" v-if="!btnDisabled" @click="updateResetPages" :disabled="btnDisabled">{{ displayPopupButtonTitle }}</md-button>        
                    <md-button class="md-primary md-raised" style="margin-bottom: 25px;" v-else :disabled="btnDisabled">{{ displayPopupButtonTitle }}</md-button>        
                </md-dialog-content>
            </div>    
        </div>
    </md-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { bookmarkRenames } from '@/lib/bookmark-labels';

const CreateProject = {
    name: 'resetPage',
    props: [
        'toolbarManuType',
        'currentPage',
        'reset_page_from',
        'reset_page_to'
    ],
    data: function() {
        return {
            addResetOption: 'default',
            addErrorFromMessage: '',
            pdfPages: [],
            working: false,
            startingNumber: 1,
            btnDisabled: false
        };
    },
    computed: {
        ...mapGetters([
            'project',
            'currentVersion',
            'projectTotalPages',
            'bookmarks'
        ]),
        isCreateDisabled() {
            return !(this.project.title && this.project.file && this.project.ownerRole);
        },
        toolbarManuTypeName() {
            return this.toolbarManuType;
        },
        displayPopupTitle() {
            return this.toolbarManuType === 'resetAllPages' ? 'First Page Number' : 'Adjust Select Page Numbers';
        },
        displayPopupButtonTitle() {
            return this.toolbarManuType === 'resetAllPages' ? 'Reset Page(s)' : 'Adjust Page(s)';
        },
        versionID: function() {
            return this.currentVersion ? this.currentVersion.id : '';
        },
        totalPages: function() {
            if (this.versionID) {
                return this.projectTotalPages || 0;
            }
            
            return (this.project && Array.isArray(this.project.pdfPageNumbers)) 
                ? this.project.pdfPageNumbers.length 
                : 0;
        }
    },
    methods: {
        addValidateNumber() {
            const value = this.startingNumber.toString().trim();
            const isPositiveInteger = /^[1-9]\d*$/.test(value);

            if (!isPositiveInteger) {
                this.btnDisabled = true;
                this.addErrorFromMessage = 'Please enter a valid positive integer.';
            } else {
                this.btnDisabled = false;
                this.addErrorFromMessage = '';
            }
        },
        open() {
            this.startingNumber = 1;
            this.addErrorFromMessage = '';
            this.$refs.resetPage.open();
            this.$emit('dialog-state-change', true);
            if (this.startingNumber > 0) {
                this.btnDisabled = false;
            }
        },
        updateResetPages() {
            this.working = true;
            const oldLabels = (this.project.pdfPageNumbers || []).map(p => p.name);
            if (this.addResetOption === 'default' && this.toolbarManuTypeName === 'resetAllPages' && this.startingNumber) {
                if (this.reset_page_from !== undefined || this.reset_page_to !== undefined) {
                    const resetPageFrom = this.reset_page_from - 1;
                    const resetPageTo = this.reset_page_to - 1;
                    let resetCounter = 1;

                    this.pdfPages = this.project.pdfPageNumbers.map((page, index) => {
                        if (index >= resetPageFrom && index <= resetPageTo) {
                            return {
                                id: page.id,
                                name: `${resetCounter++}`
                            };
                        }
                        return {
                            id: page.id,
                            name: `${page.name}`
                        };
                    });
                } else {
                    this.pdfPages = Array.from({ length: this.totalPages }, (_, i) => ({ id: i, name: `${i + 1}`}));
                }
            } else if (this.addResetOption === 'custom' || this.toolbarManuTypeName === 'adjustSelectedPages') {
                const startingNumber = Number(this.startingNumber) || 1;
                if (this.reset_page_from !== undefined || this.reset_page_to !== undefined) {
                    const resetPageFrom = this.reset_page_from - 1;
                    const resetPageTo = this.reset_page_to - 1;
                    let resetCounter = startingNumber;

                    this.pdfPages = this.project.pdfPageNumbers.map((page, index) => {
                        if (index >= resetPageFrom && index <= resetPageTo) {
                            return {
                                id: page.id,
                                name: `${resetCounter++}`
                            };
                        }
                        return {
                            id: page.id,
                            name: `${page.name}`
                        };
                    });
                } else {
                    this.pdfPages = Array.from({ length: this.totalPages }, (_, i) => ({
                        id: i,
                        name: `${startingNumber + i}`
                    }));
                }
            }
            const updatedPdfPages = this.pdfPages.map((item, index) => ({
                ...item,
                id: index
            }));
            if (this.versionID) {
                this.$store.dispatch('renameVersionPdfPages', {
                    pdfPage: updatedPdfPages
                }).then(() => {
                    this.working = false;
                });
            } else {
                this.$store.dispatch('renamePdfPages', {
                    pdfPage: updatedPdfPages
                }).then(() => {
                    this.working = false;
                });
            }
            // Only a bookmark still named "page <old label>" follows; a renamed one keeps its name.
            const newLabels = updatedPdfPages.map(p => p.name);
            // On a saved version these are the live bookmarks, so leave them alone.
            if (!this.versionID) {
                for (const rename of bookmarkRenames(this.bookmarks, oldLabels, newLabels)) {
                    this.$store.dispatch('updateBookmark', rename);
                }
            }
            this.$refs.resetPage.close();
            this.toolbarManuType = '';
            this.$emit('dialog-state-change', false);
            this.$emit('thumbnailSelectionClick', []);
        },
        closeDialog() {
            this.$refs.resetPage.close();
            this.toolbarManuType = '';
            this.$emit('dialog-state-change', false);
            this.btnDisabled = false;
        },
        cancel() {
            this.$refs.resetPage.close();
            this.toolbarManuType = '';
            this.$emit('dialog-state-change', false);
            this.btnDisabled = false;
        }
    }
};
export default CreateProject;
</script>

<style>
.md-dialog {
    min-width: 400px;
}

.from-to .md-radio {
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// reset-page.vue?7f877d6b